import {mapActions, mapGetters, mapMutations} from "vuex";
import {SET_COUNT_PRODUCTS, UPDATE_CHECKED_LIST_IN_PROPS} from '@/store/mutation-types';
import {CHECK_COUNT_PRODUCTS} from '@/store/action-types';
import _ from "lodash";

export default {
  name: 'props-select',
  data() {
    return {
      open: false,
      checked: []
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: []
    },
    slug: {
      type: String,
      default: ''
    }
  },
  created() {
    if (this.checkedList) {
      this.checkedList.forEach((e, index) => {
        if (e.slug === this.slug) {
          this.checked = this.checkedList[index].categories
        }
      })
    }
  },
  watch: {
    isResetAll() {
      if (this.isResetAll) {
        this.checked = [];
      }
    }
  },
  computed: {
    ...mapGetters({
      checkedList: 'propsSelection/checkedList',
      isResetAll: 'propsSelection/isResetAll',
      price: 'propsSelection/price',
    }),
    transformDataForGetCount() {
      let transformObj = {};
      this.checkedList.forEach(e => {
        transformObj[e.slug] = e.categories.map(t => {
          return t.slug;
        });

      });
      transformObj.price_min = this.price.min;
      transformObj.price_max = this.price.max;
      return transformObj;
    },
    selectCategories() {
      let arr = [];
      if (this.checked.length > 0) {
        this.checked.forEach(e => {
          arr.push(`<span>${e.value}</span>`);
        });
      }
      return arr.join(', ');
    }
  },
  methods: {
    ...mapMutations({
      update: `propsSelection/${UPDATE_CHECKED_LIST_IN_PROPS}`,
      setCount: `propsSelection/${SET_COUNT_PRODUCTS}`,
    }),
    ...mapActions({
      checkCount: `propsSelection/${CHECK_COUNT_PRODUCTS}`
    }),
    select() {
      this.update({slug: this.slug, categories: this.checked});
      if (this.checkedList.length === 0 && this.price.min === '' && this.price.max === '') {
        this.setCount(0)
      } else {
        this.sendRequest();
      }
    },
    sendRequest: _.debounce(function () {
      this.checkCount(this.transformDataForGetCount).finally(() => {
        if (this.checkedList.length === 0 && this.price.min === '' && this.price.max === '') {
          this.setCount(0)
        }
      });
    }, 800),
  }
}
